import { useMemo } from 'react';

export const useCollapsedVisibility = (
  stickyCollapsed: boolean,
  index: number
) => {
  return useMemo(
    () => ({
      showInCollapsed: stickyCollapsed && index === 0,
      hideInCollapsed: stickyCollapsed && index > 0,
    }),
    [stickyCollapsed, index]
  );
};

export default useCollapsedVisibility;
